import { useState } from "react";
import "@/App.css";
import { translations } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { GtaSystem } from "./components/GtaSystem";
import { WhyGta } from "./components/WhyGta";
import { IndicatorShowcase } from "./components/IndicatorShowcase";
import { Testimonials } from "./components/Testimonials";
import Stats from "./pages/Stats";
import { FAQ } from "./components/FAQ";
import { StickyCTA } from "./components/StickyCTA";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("gta_lang") || "en");
  const t = translations[lang];

  const changeLanguage = (l) => {
    localStorage.setItem("gta_lang", l);
    setLang(l);
  };

  if (window.location.pathname === "/stats") return <Stats />;

  return (
    <div className="min-h-screen bg-[#0B0E11] text-white">
      <div className="noise-overlay" />
      <Navbar t={t} lang={lang} setLang={changeLanguage} />
      <main>
        <Hero t={t} />
        <GtaSystem t={t} />
        <WhyGta t={t} />
        <IndicatorShowcase t={t} />
        <Testimonials t={t} lang={lang} />
        <FAQ t={t} />
        <FinalCTA t={t} />
      </main>
      <Footer t={t} />
      <StickyCTA t={t} />
    </div>
  );
}

export default App;
